export const ALL_CATEGORIES_CATEGORY = 'all';

export const COMPONENT_REPOSITORY_CATEGORIES = [
  'widget',
  'pageTemplate',
  'fragment',
  'plugin',
  'contentTemplate',
  'contentType',
];
